import { Plug } from "lucide-react";
import { CLAUDE_ICON_PATH, OPENAI_ICON_PATH } from "@/frontend/constants/brand-icons";

/**
 * Brand mark for a connected OAuth client, matched by its self-reported name.
 * Known assistants (Claude family, OpenAI/ChatGPT/Codex) get their brand
 * glyph; otherwise the DCR-provided `logoUrl` is shown, falling back to a
 * generic plug icon.
 */
export function ClientLogo({
  name,
  logoUrl,
  className = "size-8",
}: {
  name: string | null | undefined;
  logoUrl?: string | null;
  className?: string;
}) {
  const n = (name ?? "").toLowerCase();

  if (n.includes("claude")) {
    return (
      <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
        <rect width="24" height="24" rx="5" fill="#D97757" />
        <g transform="translate(3 3) scale(0.75)">
          <path d={CLAUDE_ICON_PATH} fill="#fff" />
        </g>
      </svg>
    );
  }
  if (n.includes("chatgpt") || n.includes("openai") || n.includes("codex")) {
    return (
      <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
        <rect width="24" height="24" rx="5" fill="#000" />
        <g transform="translate(3 3) scale(0.75)">
          <path fillRule="evenodd" d={OPENAI_ICON_PATH} fill="#fff" />
        </g>
      </svg>
    );
  }
  if (typeof logoUrl === "string" && logoUrl.length > 0) {
    return <img src={logoUrl} alt="" className={`${className} rounded object-contain`} />;
  }
  return <Plug className={`${className} rounded bg-muted p-1.5 text-muted-foreground`} />;
}
